import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class WebChannelAnalyticsSection
*  Настройки счётчика веб-аналитики<br>
*/
export class WebChannelAnalyticsSection extends ActiveModel {

  /**
  * enabled
  * Включён ли сбор веб-аналитики на витрине<br>  */
  @ActiveField(false)
  enabled: boolean = false


  /**
  * counterId
  * Номер счётчика Яндекс Метрики витрины<br>  */
  @ActiveField(null)
  counterId: null | number = null


  /**
  * ecommerceEnabled
  * Отправлять ли ecommerce-события (dataLayer)<br>  */
  @ActiveField(false)
  ecommerceEnabled: boolean = false


  /**
  * webvisorEnabled
  * Включён ли вебвизор<br>  */
  @ActiveField(false)
  webvisorEnabled: boolean = false
}
